module.exports = __webpack_public_path__ + "static/aboutMe-69564a6b226799806added5b9d361ffd.jpg";